<template>
  <ValidationObserver v-slot="{  }">
    <!-- form -->
    <div class="py-2">
      <ValidationObserver v-slot="{  }">
        <form class="bg-white pt-6 pb-8 mb-4" @submit.prevent="createFdImm">
          <div class="flex">
            <div class="mb-4 w-2/6">
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="name">Name</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  v-model="name"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="Ausg" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="ausg">Ausg</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="username"
                  type="number"
                  step="any"
                  v-model="ausg"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="Kf" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="kf">Kf</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="kf"
                  type="number"
                  step="any"
                  v-model="kf"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex">
            <div class="mb-4 w-2/6">
              <ValidationProvider name="I" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="i">I %</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="i"
                  type="number"
                  step="any"
                  v-model="ap1"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="II" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="ii">II %</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="ii"
                  type="number"
                  step="any"
                  v-model="ap2"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="III" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="iii">III %</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="iii"
                  type="number"
                  step="any"
                  v-model="ap3"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex">
            <div class="mb-4 w-2/6">
              <ValidationProvider name="Db1" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="db1">Db1</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="db1"
                  type="number"
                  step="any"
                  v-model="db1"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="KVar" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="kvar">K Var</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="kvar"
                  type="number"
                  step="any"
                  v-model="kvar"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-4 w-2/6">
              <ValidationProvider name="Fakt Werb PU" rules="required" v-slot="{ errors }">
                <label
                  class="block text-gray-700 text-sm font-bold mb-2"
                  for="faktwerbpu"
                >Fakt Werb PU</label>
                <input
                  class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="faktwerbpu"
                  type="number"
                  step="any"
                  v-model="fakt"
                />
                <span class="block text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- <div class="flex">
            <div class="mb-4 w-2/6">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="post">Select Post</label>
              <select
                v-model="service"
                class="shadow appearance-none border rounded md:w-48 lg:w-48 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option disabled value>Choose one</option>
                <option
                  v-for="(service, id) in services"
                  :value="service.id"
                  :key="id"
                >{{ service.name }}</option>
              </select>
            </div>
          </div>-->

          <div class="flex items-center">
            <button
              class="bg-teal-400 hover:bg-white hover:text-teal-400 text-white font-semibold py-2 px-4 focus:outline-none focus:shadow-outline"
              type="submit"
            >Save</button>
            <router-link
              to="/fd-imm-table"
              class="ml-10 inline-block align-baseline font-semibold text-sm text-teal-400 hover:text-teal-300"
            >Back</router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- form-->
  </ValidationObserver>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      name: "",
      ausg: "",
      kf: "",
      ap1: "",
      ap2: "",
      ap3: "",
      db1: "",
      kvar: "",
      fakt: ""
      // products: [],
      // services: [],
      // service: ""
    };
  },

  created() {
    // this.getServices();
  },
  methods: {
    createFdImm() {
      axios
        .post(`${process.env.VUE_APP_API}/calculate/imm`, {
          name: this.name,
          ausg: this.ausg,
          kf: this.kf,
          ap1: this.ap1,
          ap2: this.ap2,
          ap3: this.ap3,
          db1: this.db1,
          kvar: this.kvar,
          fakt: this.fakt
          // service: this.service
        })
        .then(() => this.$router.push("/fd-imm"))
        .catch(error => console.log(error));
    }
    // getServices() {
    //   axios
    //     .get(`${process.env.VUE_APP_API}/calculate/services`)
    //     .then(response => {
    //       this.services = response.data;
    //     });
    // }
  }
};
</script>

<style>
</style>